import { render, staticRenderFns } from "./totals.vue?vue&type=template&id=f93bb95a&"
import script from "./totals.vue?vue&type=script&lang=js&"
export * from "./totals.vue?vue&type=script&lang=js&"
import style0 from "./totals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports